import React from 'react'
import { Icon, Card, Label, RadioGroup, CriticalRadio, Button } from '../../../atoms'

interface Product {
  name: string
  icon: string
  text: string
  buttonText: string
  href: string
}

interface ProductNavigationProps {
  heading: string
  subheading: string
  products: Product[]
}

const ProductNavigation = ({
  jsonBody: { heading, subheading, products },
  ...props
}: {
  jsonBody: ProductNavigationProps
}) => {
  /* eslint-disable camelcase */
  const dataClickTracking = {
    component_category: 'platinum-module',
    component_id: props.sys?.id,
    component_name: 'productNavigation',
    contentful_name: props.name,
    contentful_variant: props.variant,
  }
  return (
    <div className='ProductNavigation' data-tabs-selector>
      <Card variant='plum'>
        <h2 className='ProductNavigation__title'>{heading}</h2>
        <div className='ProductNavigation__inner-card'>
          <Label>{subheading}</Label>
          <RadioGroup stack={true}>
            {products.map((product, index) => {
              return (
                <CriticalRadio
                  key={index}
                  name={`product-navigation-${heading}`}
                  centerLabel={true}
                  buttonAlignment={'top-left'}
                  checked={index === 0}
                  buttonActions={{
                    'data-tabs-selector-radio': index,
                    'data-click-tracking': JSON.stringify({
                      ...dataClickTracking,
                      additionalProps: {
                        name: product.name,
                        index,
                      },
                    }),
                  }}
                >
                  <div className='ProductNavigation__radioButton'>
                    <Icon glyph={product.icon} size={32} color={'#34454E'} />
                    <div className='ProductNavigation__radioButton__text'>
                      <span className='ProductNavigation__radioButton__label'>{product.name}</span>
                    </div>
                  </div>
                </CriticalRadio>
              )
            })}
          </RadioGroup>
        </div>

        {products.map((product, index) => {
          return (
            <div
              data-tabs-selector-content
              key={index}
              style={{ display: index === 0 ? 'block' : 'none' }}
            >
              <div className='ProductNavigation__text'>{product.text}</div>
              <div className='ProductNavigation__cta'>
                <Button
                  href={product.href}
                  withIcon={false}
                  dataClickTracking={{
                    ...dataClickTracking,
                    additionalProps: {
                      name: product.name,
                      buttonText: product.buttonText,
                      href: product.href,
                    },
                  }}
                >
                  {product.buttonText}
                </Button>
              </div>
            </div>
          )
        })}
      </Card>
    </div>
  )
}

export default ProductNavigation
